<script setup lang="ts">
  import type { IBreadcrumb } from '@/components/breadcrumbs/types'

  defineProps<{
    blok: any
    breadcrumbs: IBreadcrumb[]
  }>()

  const { isDesktop } = useBTBreakpoints()
</script>

<template>
  <section class="flex flex-col gap-6 md:gap-10">
    <Breadcrumbs
      v-if="breadcrumbs.length && isDesktop"
      :breadcrumbs="breadcrumbs"
      :has-hero="!!blok?.hero?.filename"
    />

    <div class="container mb-20 flex flex-col gap-6">
      <template
        v-for="section in blok.body"
        :key="section._uid"
      >
        <StoryblokComponent
          :is="section.component"
          v-if="section.component"
          v-editable="section"
          :blok="section"
        />
      </template>
    </div>
  </section>
</template>
